/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-14 14:27:35
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-02-14 15:12:28
 * @name: 工单管理-快递公司列表
 * @Description: 工单管理-快递公司列表
 * @FilePath: \preSaleNafterSaleInside\project\src\Validator\issue\getPackageCompanyList.js
 * @Author: desktop
 */
export const validator = [
  {
    key: 'name',
    description: '快递公司名称(模糊查询)',
    required: true,
    required_message: 'name为必传项',
    match: (e) => {
      return '';
    }
  },
]